//ユーザーCSVアップロードページ
import React, { Fragment, useState } from 'react';
import { Typography, Button, Form, message, Input, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
// import config from '../../Config/key';
import Papa from 'papaparse';
import {
  decodeCsvBuffer,
  validateCsvHeaders,
  formatHeaderValidationError,
  extractAxiosErrorMessage,
} from '../../../utils/csvUploadHelper';
// import { forEach } from 'core-js/core/array';
// const bcrypt = require('bcrypt');
// const saltRounds = 10;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

// CSV に必須の列（email のみ）
const REQUIRED_COLUMNS = ['email'];

function CSVUserMergePage(props) {
  const [fileData, setFileData] = useState();
  const [fileJSON, setFileJSON] = useState();
  const [groups, setGroups] = useState([]); //グループ名とグループコード

  // const [projectDescriptionValue, setProjectDescriptionValue] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [submitButtonDisable, setSubmitButtonDisable] = useState(true);

  const onDrop = async (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    reader.onload = (e) => {
      //ファイルの読み込みが終わったら発火
      // decodeCsvBuffer で文字コード自動判定 + 先頭 BOM 除去まで一括処理
      const unicodeString = decodeCsvBuffer(e.target.result);
      Papa.parse(unicodeString, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: async (results) => {
          // 必須列の存在検証（BOM は decodeCsvBuffer で除去済み、その他不可視文字を捕捉）
          const headers = (results.meta && results.meta.fields) || [];
          const v = validateCsvHeaders(headers, REQUIRED_COLUMNS);
          if (!v.ok) {
            message.error({
              content: formatHeaderValidationError(v),
              key: 'csvupload',
              duration: 10,
            });
            setFileJSON(undefined);
            setFileData(
              'エラー：CSVヘッダーを確認の上、再アップロードしてください。'
            );
            return;
          }
          setFileData(unicodeString);
          setFileJSON(results.data);
          //const courseInfo = courseMerge(results.data);
          // setProjectKeyValue(`${courseInfo.course_id}_${ymdhms()}`);
          // console.log({ courseInfo });
        },
      });
    };
    reader.readAsArrayBuffer(file); //ファイルを読み込む
    const group = await Axios.get('/api/group/');
    setGroups(group.data.groups);
    // console.log(group.data.groups);
  };

  //yyyymmddhhmmss
  const ymdhms = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let userEmail = []; //最終分類用
    try {
      message.loading({
        content: 'データ変換中...',
        key: 'csvupload',
        duration: 20,
      });

      // CSV が正常に読み込まれているかを確認（必須列検証で弾かれた場合は fileJSON が undefined）
      if (!fileJSON || !Array.isArray(fileJSON) || fileJSON.length === 0) {
        message.error({
          content:
            '有効なCSVファイルがアップロードされていません。CSVを再確認してください。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVデータがありません。');
      }

      // console.log(groupCode);
      if (groupCode !== 'NTA' && groupCode !== 'NTAGP') {
        message.error({
          content: '正しい企業コードを選択してください。',
          key: 'csvupload',
          duration: 2,
        });
        throw new Error('正しい企業コードが選択されていません。');
      }

      await fileJSON.map((record) => {
        userEmail.push(record.email);
      });
      const sendData = {
        userEmail,
        groupCode,
      };
      const res = await Axios.post('/api/users/csvusermerge', sendData);
      // console.log({ res });
      if (res.data.success) {
        message.success({
          content: 'データ変換完了！',
          key: 'csvupload',
          duration: 2,
        });
        setTimeout(() => {
          props.history.push('/csvusermerge');
        }, 1000);
      }
      // message.success({
      //   content: 'データ変換完了！',
      //   key: 'csvupload',
      //   duration: 2,
      // });
      // message.error({
      //   content: 'データ変換に失敗しました。',
      //   key: 'csvupload',
      //   duration: 2,
      // });
      // throw new Error('データ変換に失敗しました。');
    } catch (error) {
      console.log({ error });
      // バックエンドの具体的なエラー本文を抽出して表示（運用担当が pm2 logs 参照不要）
      message.error({
        content: extractAxiosErrorMessage(
          error,
          'データ変換に失敗しました。'
        ),
        key: 'csvupload',
        duration: 5,
      });
    }
  };

  const onChangeGroup = (value) => {
    if (value) {
      setGroupCode(value);
      setSubmitButtonDisable(false);
    }
    // console.log(e);
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>日本旅行グループアカウント統合</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Drop zone */}
            <Dropzone onDrop={onDrop} multiple={false} maxSize={1000000000}>
              {({ getRootProps, getInputProps }) => (
                <div
                  style={{
                    width: '300px',
                    height: '240px',
                    border: '1px solid lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <PlusOutlined style={{ fontSize: '3rem' }} />
                </div>
              )}
            </Dropzone>
            <div
              style={{
                width: '300px',
                height: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text mark>
                CSVファイルをDrag &
                Dropするか、+を押してファイルを選択してください。
              </Text>
            </div>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeGroup}
                value={groupCode}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groups.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element.group_code} key={element._id}>
                      {element.group_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            <br />
          </div>
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            disabled={submitButtonDisable}
          >
            メール確認
          </Button>
        </Form>
        <TextArea rows={20} value={fileData} />
      </div>
    </Fragment>
  );
}

export default CSVUserMergePage;
